import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { PatientService } from '../../../services/patient.service';
import { PatientTransactions } from '../../../models/PatientTransactions';
import { PromiseResult, ServerError } from '../../../models/PromiseResult';
import { BreadcrumbService } from '../shared/breadcrumb.service';
import { invoice } from 'src/app/models/invoice';
import { patientRefundBody } from '../../../models/Accounts';
import {
  LazyLoadEvent,
  MessageService,
  MultiSelectItem,
  SelectItem
} from 'primeng';
import { TraceClassDecorator } from '@sentry/angular';
import { PaginationModel } from '../../../models/util.models';
import { saveAs } from 'file-saver';
import { ProviderStateService } from 'src/app/services/provider-state.service';


@Component({
  selector: 'app-transactions',
  templateUrl: './transactions.component.html',
  styleUrls: ['../../../../assets/css/custom-egd.css']
  // encapsulation: ViewEncapsulation.None
})
@TraceClassDecorator()
export class TransactionsComponent implements OnInit {
  memberValue: string = null;
  members: SelectItem[] = [];
  TZ = Intl.DateTimeFormat().resolvedOptions().timeZone;
  invoice_id: string = '';
  api_url: string = '';
  transaction_no: number = 0;
  data: invoice;
  success: boolean = null;
  error: string = '';
  refresh: boolean = false;
  selectedMemberName: string;
  displayModal: boolean = false;
  showInvoice: string = 'showInvoice';
  printContent: string = 'print-content';
  slug: string = "";

  constructor(
    private readonly titleService: Title,
    private readonly patientservice: PatientService,
    private readonly breadcrumbService: BreadcrumbService,
    private readonly messageService: MessageService,
    private readonly providerStateService: ProviderStateService
  ) {
    
    this.query = {
      page_no: 1,
      records_per_page: 10
    };
  }
  Transactions: PatientTransactions[] = [];
  query: PaginationModel = new PaginationModel();
  total_records = 0;
  result: PromiseResult;
  serverError: ServerError = new ServerError();
  body: patientRefundBody = new patientRefundBody();
  refundBool: boolean = false;
  private ResetResultModels(): void {
    this.result = new PromiseResult();
    this.serverError = new ServerError();
  }
  async getMemberList() {
    let temp = [];
    await this.patientservice
      .getMember(sessionStorage.getItem('userid'))
      .toPromise()
      .then((result) => {
        if (result.success) {
          for (let i = 0; i < result.data.patient.length; i++) {
            temp.push({
              label:
                ' ' +
                result.data.patient[i].first_name +
                ' ' +
                (result.data.patient[i].middle_name==null?'':result.data.patient[i].middle_name) +
                ' ' +
                result.data.patient[i].last_name +
                ' ',
              value: result.data.patient[i].patient_guid
            });
          }
          this.members = temp;
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }

  async ngOnInit() {
    this.slug = this.providerStateService.getProviderSlug();
    this.breadcrumbService.setItems([
      { label: 'Dashboard', routerLink:['/', this.slug, 'patient'] },
      { label: 'Transactions' }
    ]);
    this.SetTitle('Dashboard - Transactions');
    await this.getMemberList();
    //this.getPatientTransactions();
  }

  async onChange(memberValue: string): Promise<void> {
    this.refresh = true;
    this.memberValue = memberValue;
    this.query = {
      page_no: 1,
      records_per_page: 10
    };
    this.total_records = 0;
    await this.getPatientTransactions(null);

    this.refresh = false;
  }

  async getPatientTransactions(event: LazyLoadEvent) {
    if (event) {
      this.query.page_no = event.first / event.rows + 1;
      this.query.records_per_page = event.rows;
    }
    // this.Transactions = [];
    await this.patientservice
      .getTransactions(this.memberValue, this.query)
      .toPromise()
      .then((result) => {
        this.result = result;
        this.total_records = result.data.count;
        const transactions_data = result.data.rows;
        let temp_data: PatientTransactions[] = [];
        if (transactions_data.length > 0) {
          for (let i = 0; i < transactions_data.length; i++) {
            let temp_data_transactions_obj: PatientTransactions = {
              SrNo:
                i + 1 + (this.query.page_no - 1) * this.query.records_per_page,
              patient_guid: this.memberValue,
              member: '',
              date: transactions_data[i].created_at,
              invoice_url: transactions_data[i].p_invoice?.invoice_url || null,
              invoice_key: transactions_data[i].p_invoice?.invoice_key,
              transactionType:
                transactions_data[i].user_package == null
                  ? transactions_data[i].p_priority?.consultation_name
                  : transactions_data[i].p_consultation == null
                  ? transactions_data[i].p_priority?.consultation_name ==
                      'Health Passport' || 'N/A'
                  : transactions_data[i].user_package.package_type
                      .package_name +
                    ' ' +
                    'Package',
              transactionNumber: transactions_data[i].transaction_no,
              paidThrough: transactions_data[i].payment_gateway_type,
              amount: transactions_data[i].amount,
              code: transactions_data[i].currency_type,
              invoice:
                transactions_data[i].p_invoice == null
                  ? null
                  : transactions_data[i].p_invoice.invoice_id,
              transaction_id: transactions_data[i].id,
              status: transactions_data[i].status,
              is_package:
                transactions_data[i].user_package == null ? false : true,
              isConsultationNotClosed:
                transactions_data[i].p_consultation?.consultation_status !=
                  'CLOSED' || false,
              isDietConsultation:
                transactions_data[i].p_priority == null
                  ? false
                  : transactions_data[i].p_priority.consultation_type_id == 5 ||
                    false
            };
            temp_data.push(temp_data_transactions_obj);
          }
          this.Transactions = temp_data;
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }

  async displayDialog(transaction_id: string) {
    await this.GetInvoice(transaction_id);
  }
  fetched: PromiseResult;

  async getInvoiceBase64(api_url: string) {
    this.api_url = api_url;
    await this.patientservice
      .GetBase64FromUrl(this.api_url)
      .toPromise()
      .then((result) => {
        if (result.success) {
          this.downloadFile(result.data.base64, result.data.filename);
        }
      });
  }

  downloadFile(base64Data: string, filename: string) {
    // Convert base64 to a Blob
    const byteCharacters = atob(
      base64Data.replace(/^data:application\/pdf;base64,/, '')
    );
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/pdf' });
    saveAs(blob, filename);
  }

  async openRefundDialog(transaction_id: string): Promise<void> {
    this.body.transaction_id = transaction_id;
    this.refundBool = transaction_id != null;
    this.refund_message = '';
    this.body.refund_reason = '';
    this.shouldShowOnSuccess = false;
    this.ResetResultModels();
  }
  async GetInvoice(transaction_id: string) {
    await this.patientservice
      .fetchInvoice(transaction_id)
      .toPromise()
      .then((result) => {
        this.fetched = result.data;

        if (!result.success) {
          this.success = false;
          this.error = result.error.message;
        } else {
          this.success = true;
          this.displayModal = true;
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }

  print() {
    window.print();
  }

  SetTitle(title: string) {
    // let Title=this.titleService.getTitle().split(" ");
    // let notif=Title[0].substr(1,Title[0].length-2);
    this.titleService.setTitle(title);
  }
  shouldShowOnSuccess: boolean = false;
  refund_message = '';
  async submitRefind(): Promise<void> {
    this.refresh = true;
    this.result = new PromiseResult();
    this.serverError = new ServerError();
    await this.patientservice
      .patientRefund(this.body)
      .toPromise()
      .then(async (result: PromiseResult) => {
        this.result = result;
        this.refresh = false;
        if (result.success) {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Your request has been successfully refunded.'
          });
          this.shouldShowOnSuccess = true;
          this.refund_message = result.data.message;
          await this.getPatientTransactions(null);
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: result.error.message
          });
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }
}
